import prd_vBNrxygcjjdQ from '@/data/products/one-time/prd_vBNrxygcjjdQ'
import prd_4JY2zE5skUWg from '@/data/products/one-time/prd_4JY2zE5skUWg'
import prd_9S0XOkYSpnPv from '@/data/products/one-time/prd_9S0XOkYSpnPv'
import prd_Fc1t7ISC6VLT from '@/data/products/one-time/prd_Fc1t7ISC6VLT'
import prd_fHjX92z7dCgG from '@/data/products/one-time/prd_fHjX92z7dCgG'
import prd_HLkXsf2aTCZ8 from '@/data/products/one-time/prd_HLkXsf2aTCZ8'
import type { UpsellTemplateSchema, UpsellTemplateStepConfig, UpsellStepsArgs } from '../@types/upsell-types'
import type { OneTimeProduct } from '@/composables/useProducts'
import { mergeDeep } from '@/helpers/utils'

export default (schema: UpsellTemplateSchema<OneTimeProduct>): UpsellTemplateSchema<OneTimeProduct> =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				steps: ({ isRoWCountry, countryCode }: UpsellStepsArgs): UpsellTemplateStepConfig[] => {
					if (countryCode === 'us') {
						return [
							{
								product: prd_vBNrxygcjjdQ.ident,
								discountPercent: 45,
								modals: {
									skip: ['UpsellSkipUnwrapModal', 'UpsellSkipAnimationModal'],
								},
							},
							{
								product: prd_4JY2zE5skUWg.ident,
								discountPercent: 60,
							},
						]
					}

					return [
						{
							product: isRoWCountry ? prd_fHjX92z7dCgG.ident : prd_9S0XOkYSpnPv.ident,
							discountPercent: isRoWCountry ? 46 : 40,
							modals: {
								skip: ['UpsellSkipUnwrapModal', 'UpsellSkipAnimationModal'],
							},
						},
						{
							product: isRoWCountry ? prd_HLkXsf2aTCZ8.ident : prd_Fc1t7ISC6VLT.ident,
							discountPercent: 60,
						},
					]
				},
			},
		},
	)
